import { Button } from "primereact/button";
import { Fragment, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { emailValidation } from "../sessions/session.service";
import { Toast } from "primereact/toast";
import { Loading } from "app/components";
import { useMediaQuery } from "react-responsive";
import { useDispatch } from "react-redux";
import { RadioButton } from "primereact/radiobutton";
import { getSessionUserInformation } from "app/utils/utility.service";
import { setSessionUserInformation } from "app/utils/utility.service";
import { InputText } from "primereact/inputtext";
import { validateEmail } from "app/utils/utility.service";
import { updateRentDownPayment } from "./HomePurchaseStep3/homepurchase.service";
import { inviteBroker } from "../clients/clients.service";
import { ErrorToastConfig } from "app/utils/ToastConstants";
import { sendNewAccountEmail } from "../agents/agents.service";
import { updateFreePlan } from "../subscription/subscription.service";

const initialState = {
  firstName: "",
  lastName: "",
  phoneNumber: "",
  email: "",
  password: "",
  city: "",
  state: "",
  country: "United States",
  zipcode: "",
  address: "",
  brokerEmail: "",
  brokerCompany: "",
  brokerFirstName: "",
  brokerLastName: "",
  brokerPhoneNumber: "",
};

const HomePurchaseRoleSelection = () => {
  const [email, setEmail] = useState("");
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [termsofServiceModal, setTermsofServiceModal] = useState(false);
  const [privacyModal, setPrivacyModal] = useState(false);
  const toast = useRef();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const sessionValues = getSessionUserInformation();
  const showError = (message) => {
    toast.current.show(ErrorToastConfig(message ? message : "Error"));
  };

  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 1224px)",
  });
  const options = ["Client", "Agent", "Broker"];
  const [values, setValues] = useState(initialState);

  const [option, setOption] = useState(options[0]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setValues({ ...values, [name]: value });
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    sessionValues.roleId = option === "Client" ? 4 : option === "Agent" ? 3 : 2;
    setSessionUserInformation(sessionValues);
    let req = sessionValues;
    req.roleId = sessionValues.roleId;
    req.companyName = values.companyName;
    req.phoneNumber = values.phoneNumber;

    const isAgent = option === "Agent";
    if (isAgent) {
      req.inviteBroker = true;
    }
    const isBrokerOrAgent = isAgent || option === "Broker";
    if (isBrokerOrAgent) {
       const record  = await updateRentDownPayment(req, sessionValues.id);
       if (!!record?.data) {   
        await updateFreePlan(sessionValues.id, { roleId: sessionValues.roleId });
        await sendNewAccountEmail({
                email: sessionValues.email,
                firstName: sessionValues.firstName,
                lastName: sessionValues.lastName,
                role: isAgent? "Agent": "Broker"
              });
        if (isAgent) {
              
              let req = {};
              req.email = encodeURIComponent(values.brokerEmail);
              req.id = sessionValues.id;
              req.companyName = values.brokerCompany;
              req.phoneNumber = values.brokerPhoneNumber;
              req.firstName = values.brokerFirstName;
              req.lastName = values.brokerLastName;
              req.clientid = "";
              req.senderName = sessionValues.firstName + " " + sessionValues.lastName;
              await inviteBroker(req);
            }
       }  else {
        showError(record?.message);
      }
    
    
    }
    if (option === "Client") {
      const record  = await updateRentDownPayment(sessionValues, sessionValues.id);
      if (!!record?.data) {  
        navigate("/home-purchase/step0");
      } else {
        showError(record?.message);
      }
    } else {
      navigate(`/`);
    }
  };

  return (
    <div className="center-align HomePurchaseRentForm">
      {isLoading && <Loading />}
      <Toast ref={toast} className="ToastMessage" />
      <div

      >
        <form onSubmit={onSubmit} method="POST">
          <div className="role-selector">
            <div className="welcome-row">
              <label className="role-label" style={{marginLeft:"5px"}}>
                Welcome to MyHouser!
              </label>
            </div>
           <div className="profile-row">
              <span className="role-label" style={{marginLeft:"5px"}}>Profile:</span>
           
            {options.map((optionSel) => (

              <div key={optionSel}
                className={`role-option ${option === optionSel ? 'active' : ''}`}>

                <RadioButton
                  name="option"
                  value={optionSel}
                  onChange={(e) => setOption(e.value)}
                  checked={option === optionSel}

                />

                <label htmlFor={optionSel} className="role-label" >
                  {optionSel}
                </label>
              </div>

            ))}
            </div>
          </div>
          <div className="grid">
            {option === 'Agent' && (
              <Fragment>
                <div className="content col-12 ">

                  <div className="col-12 md:col-6 lg:col-6 content pr-5 pl-2 mb-5">
                      <div>
                        <span className="p-float-label">
                          <InputText
                            className="vw-input"
                            autoComplete="off"
                            required
                            name="phoneNumber"
                            value={values?.phoneNumber}
                            onChange={handleInputChange}
                          />
                          <label> Phone No *</label>
                        </span>
                        {formSubmitted && !values?.phoneNumber && (
                          <small className="p-error">Please enter phone number</small>
                        )}
                      </div>
                    </div>

                  <label className="email-label"> Please provide Broker details for invitation. Your premium
                    subscription benefits will start once your broker signs up!
                  </label>

                </div>

                <div className="grid ml-2">
                  {/* Row 1 */}
                  <div className="col-12 md:col-6 lg:col-6 content pr-5 pl-2 mb-5">
                    <div>
                      <span className="p-float-label">
                        <InputText
                          className="vw-input"
                          autoComplete="off"
                          required
                          name="brokerEmail"
                          value={values?.brokerEmail}
                          onChange={handleInputChange}
                        />
                        <label> Email address *</label>
                      </span>
                      {formSubmitted && !values?.brokerEmail && (
                        <small className="p-error">Please enter broker email address</small>
                      )}
                      {formSubmitted && values?.brokerEmail && !validateEmail(values?.brokerEmail) && (
                        <small className="p-error">Invalid broker email address</small>
                      )}
                    </div>
                  </div>

                  <div className="col-12 md:col-6 lg:col-6 content pr-2 pl-2 ">
                    <div>
                      <span className="p-float-label">
                        <InputText
                          className="vw-input"
                          autoComplete="off"
                          required
                          name="brokerCompany"
                          value={values?.brokerCompany}
                          onChange={handleInputChange}
                        />
                        <label> Company Name *</label>
                      </span>
                      {formSubmitted && !values?.brokerCompany && (
                        <small className="p-error">Please enter broker company name</small>
                      )}
                    </div>
                  </div>

                  {/* Row 2 - Agent only */}

                  <>
                    <div className="col-12 md:col-6 lg:col-6 content pr-5 pl-2 mb-5">
                      <div>
                        <span className="p-float-label">
                          <InputText
                            className="vw-input"
                            autoComplete="off"
                            required
                            name="brokerFirstName"
                            value={values?.brokerFirstName}
                            onChange={handleInputChange}
                          />
                          <label> First Name *</label>
                        </span>
                        {formSubmitted && !values?.brokerFirstName && (
                          <small className="p-error">Please enter broker first name</small>
                        )}
                      </div>
                    </div>

                    <div className="col-12 md:col-6 lg:col-6 content pr-2 pl-2">
                      <div>
                        <span className="p-float-label">
                          <InputText
                            className="vw-input"
                            autoComplete="off"
                            required
                            name="brokerLastName"
                            value={values?.brokerLastName}
                            onChange={handleInputChange}
                          />
                          <label> Last Name *</label>
                        </span>
                        {formSubmitted && !values?.brokerLastName && (
                          <small className="p-error">Please enter broker last name</small>
                        )}
                      </div>
                    </div>

                    <div className="col-12 md:col-6 lg:col-6 content pr-5 pl-2 ">
                      <div>
                        <span className="p-float-label">
                          <InputText
                            className="vw-input"
                            autoComplete="off"
                            required
                            name="brokerPhoneNumber"
                            value={values?.brokerPhoneNumber}
                            onChange={handleInputChange}
                          />
                          <label> Phone No *</label>
                        </span>
                        {formSubmitted && !values?.brokerPhoneNumber && (
                          <small className="p-error">Please enter broker phone number</small>
                        )}
                      </div>
                    </div>
                  </>

                </div>
              </Fragment>
            )}
             </div>
            {option === 'Broker' && (
              <Fragment>      
                 <div className="grid">                               
                <div className="col-12 md:col-6 lg:col-6 content pr-5 pl-2 ">
                <div>
                  <span className="p-float-label">
                    <InputText
                      className="vw-input"
                      autoComplete="off"
                      required
                      name="companyName"
                      value={values?.companyName}
                      onChange={handleInputChange}
                    />
                    <label> Company Name *</label>
                  </span>
                  {formSubmitted && !values?.companyName && (
                    <small className="p-error">Please enter company name</small>
                  )}
                </div>
              </div>
                <div className="col-12 md:col-6 lg:col-6 content pr-2 pl-5 ">
                  <div>
                    <span className="p-float-label">
                      <InputText
                        className="vw-input"
                        autoComplete="off"
                        required
                        name="phoneNumber"
                        value={values?.phoneNumber}
                        onChange={handleInputChange}
                      />
                      <label> Phone No *</label>
                    </span>
                    {formSubmitted && !values?.phoneNumber && (
                      <small className="p-error">Please enter phone number</small>
                    )}
                  </div>
                </div>
                </div>   
              </Fragment>

            )}
         
          <div className="grid pl-3">
          <Button
            onClick={() => navigate(-1)}
            type="button"
            label="Cancel"
            className="p-button-raised p-button-lg mr-4 mt-6"
          />
          {/* </Link> */}
          <Button
            // onClick={handleSubmit}
            label="Continue"
            className="p-button-raised p-button-warning p-button-lg mr-4 mt-6"
          />
          </div>
        </form>
      </div>
    </div>
  );
};

export default HomePurchaseRoleSelection;
